import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import Logo from '../components/Logo'
import api from '../api/client'
import { useAuthStore } from '../store/auth'
import { useTenantStore } from '../store/tenant'

export default function Login() {
  const navigate = useNavigate()
  const setAuth = useAuthStore((s) => s.setAuth)
  const tenant = useTenantStore()
  const [form, setForm] = useState({ username: '', password: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  // Back to the apex landing (branch cards). From a branch login, clear the
  // active branch first so we don't bounce straight back into /login.
  const goHome = () => {
    if (tenant.isBranch) tenant.switchBranch(null)
    navigate('/')
  }

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const { data } = await api.post('/auth/login', form)
      setAuth(data.token, data.user)
      // Everyone lands on the dashboard ('/' → Home → /dashboard). It self-guards:
      // a super-admin on apex sees the all-branch view (and can click into one);
      // a branch user sees their branch summary.
      navigate('/')
    } catch (err) {
      setError(err.response?.data?.error || 'เกิดข้อผิดพลาด')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-page flex flex-col items-center justify-center px-4">
      {/* Branding strip */}
      <div className="mb-6 text-center">
        <Logo size={64} className="mx-auto mb-3 drop-shadow-md" />
        <h1 className="text-2xl font-bold text-ink">Air System</h1>
        <p className="text-sm text-ink-muted mt-1">Technical Water Co.,Ltd</p>
        {tenant.isBranch && (
          <p className="text-sm font-medium text-primary mt-1">{tenant.name}</p>
        )}
      </div>

      <div className="card w-full max-w-sm shadow-md">
        <form onSubmit={submit} className="flex flex-col gap-4">
          <div>
            <label className="label">ชื่อผู้ใช้</label>
            <input
              className="input"
              type="text"
              autoComplete="username"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="label">รหัสผ่าน</label>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
            />
          </div>
          {error && (
            <p className="text-sm text-danger bg-danger-soft rounded-input px-3 py-2">{error}</p>
          )}
          <button type="submit" disabled={loading} className="btn-primary mt-2 w-full text-center py-3">
            {loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
          </button>
        </form>
      </div>

      <button onClick={goHome} className="mt-5 inline-flex items-center gap-1.5 text-sm text-ink-muted hover:text-primary">
        <ArrowLeft className="h-4 w-4" /> กลับหน้าหลัก
      </button>
    </div>
  )
}
